
import { Component, Vue } from "vue-property-decorator";
import api from "../../network/api";
import { Avatar } from "@/models/Avatar";
import { AxiosError, AxiosResponse } from "axios";

@Component
export default class UserProfilePage extends Vue {
  private username = "";
  private firstname = "";
  private lastname = "";
  private email = "";
  private avatar: any = {};

  /**
   * Retrieve User Data before Page Finishes Loading
   * @return Json
   */
  created() {
    api.get("user/profile").then((response: AxiosResponse) => {
      this.username = response?.data?.user?.username;
      this.firstname = response?.data?.user?.first_name;
      this.lastname = response?.data?.user?.last_name;
      this.email = response?.data?.user?.email;
      this.avatar = response?.data?.user?.avatar;

      if (this.avatar == null) {
        this.avatar = {
          avatar: ""
        };
      }
    });
  }

  changeAvatar(files: FileList) {
    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    // eslint-disable-next-line no-undef
    reader.onload = () => {
      const avatar = { avatar: reader.result };
      api
        .post("user/avatar", avatar, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        })
        .then(response => {
          this.avatar = avatar;
        })
        .catch(error => {
          //ignore error
        });
    };
    reader.onerror = error => {
      // ignore, image fails to render
    };
  }

  returnToUserProfilePage() {
    this.$router.push("/userprofile");
  }

  removeAvatar() {
    api
      .delete("user/avatar")
      .then((res: AxiosResponse) => {
        this.avatar = null;
      })
      .catch((err: AxiosError) => {
        console.log(err.response);
      });
  }
}
